import { Route, Routes } from "react-router-dom";
import DetailsPage from "./Components/DetailsPage";
import Footer from "./Components/Footer";
import Header from "./Components/Header";
import Home from "./Components/Home";
import "./Components/main.css";
import Popular from "./Components/Popular";
import SearchMovies from "./Components/searchMovies/SearchMovies";
import TopRated from "./Components/TopRated";
import Upcoming from "./Components/Upcoming";
import MovieGenre from "./Designs/MovieGenre";
import UserLogin from "./UserLogin/UserLogin";
import { useSelector } from "react-redux";
import CartPage from "./Cart/CartPage";
import AllCast from "./Designs/AllCast";
import NewCarousel from "./Designs/NewCarousel";

function App() {
  const moviesInfoUser = useSelector((state) => state.users.username);
  return (
    <div className="dark">
      <div className="main-container">
        {moviesInfoUser === "" ? (
          <UserLogin />
        ) : (
          <>
            <Header />

            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/popular" element={<Popular />} />
              <Route path="/caro" element={<NewCarousel />} />
              <Route path="rated" element={<TopRated />} />
              <Route path="upcoming" element={<Upcoming />} />
              <Route path="/watchlist" element={<CartPage />} />
              <Route path="search" element={<SearchMovies />} />
              <Route path="movie/:userid" element={<DetailsPage />} />
              <Route path="genre/:genres" element={<MovieGenre />} />
              <Route path="/cast/:castid" element={<AllCast />} />
              <Route
                path="/*"
                element={<h1 className="center">Page Not Found</h1>}
              />
            </Routes>
            <Footer />
          </>
        )}
      </div>
    </div>
  );
}

export default App;
